import { ragRequest, ragStreamRequest, ragStreamRequestFull } from '../utils/request.js'
import { enhancedRequest } from '../utils/request.js'

// 获取模板列表（英语口语专用，使用 RAG 接口路径，支持传入自定义 token）
// GET /api/v1/ai/english/spoken/chat/prompt
const getPromptList = (token = null) => ragRequest({
  url: `/api/v1/ai/english/spoken/chat/prompt`,
  method: 'get',
  token: token // 传入自定义 token（aiToken）
})

// 创建新对话（英语口语专用，使用 RAG 接口路径，支持传入自定义 token）
// POST /api/v1/ai/english/spoken/chat/new
// Body 参数：modelType, promptId, message, nickname, grade, word
const newChat = (data, token = null) => ragRequest({
  url: `/api/v1/ai/english/spoken/chat/new`,
  method: 'post',
  data: data, // 请求体参数：modelType, promptId, message, nickname, grade, word
  token: token // 传入自定义 token（aiToken）
})

// 文字转音频（der包大模型有感情版本）（流式）
// POST /api/v1/ai/english/spoken/resultByTextToTTs
// Body 参数：prompt（报告内容）, reportId（报告Id，可选）
// 使用 ragStreamRequestFull 以获取完整的 JSON 对象（包含 audioBase64 等字段）
const resultByTextToTTs = (data = {}, onMessage, token = null) => ragStreamRequestFull({
  url: `/api/v1/ai/english/spoken/resultByTextToTTs`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
}, onMessage)

// 关闭对话音频通话
// DELETE /api/v1/ai/english/spoken/audioClose/{recordId}
// Path 参数: recordId (必需)
// Header 参数: X-Authorization-Token (可选，通过 token 参数传入)
const audioClose = (recordId, token = null) => ragRequest({
  url: `/api/v1/ai/english/spoken/audioClose/${recordId}`,
  method: 'delete',
  data: {}, // 不需要 body 参数
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

// 关闭对话
// DELETE /api/v1/ai/english/spoken/chat/{chatRecordId}
// Path 参数: chatRecordId (必需)
// Header 参数: X-Authorization-Token (可选，通过 token 参数传入)
const closeChat = (chatRecordId, token = null) => ragRequest({
  url: `/api/v1/ai/english/spoken/chat/${chatRecordId}`,
  method: 'delete',
  data: {}, // 不需要 body 参数
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

// 英语口语-发送消息（支持传入自定义 token）
// POST /api/v1/ai/english/spoken/chat/completions
// Body 参数：chatRecordId, message, imageUrl, ext, nickname, grade
const sendSpokenChatCompletions = (data = {}, token = null) => ragRequest({
  url: `/api/v1/ai/english/spoken/chat/completions`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
})

// 英语口语-发送消息（流式）（支持传入自定义 token）
// POST /api/v1/ai/english/spoken/chat/completions
const sendSpokenChatCompletionsStream = (data = {}, onMessage, token = null) => ragStreamRequest({
  url: `/api/v1/ai/english/spoken/chat/completions`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
}, onMessage)

// 历史对话查询（分页）
// GET /api/v1/ai/english/spoken/chat/page
// Query 参数：promptId (可选), page (可选), pageSize (可选)
// Header 参数：X-Authorization-Token (可选，通过 token 参数传入)
const getChatHistoryPage = (params = {}, token = null) => ragRequest({
  url: `/api/v1/ai/english/spoken/chat/page`,
  method: 'get',
  data: params, // Query 参数：promptId, page, pageSize（GET 请求时会将 data 作为 query 参数）
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

// 英语主题对话-历史对话查询（分页）
// GET /api/v1/ai/english/theme/chat/page
// Query 参数：page (可选), pageSize (可选)
// Header 参数：X-Authorization-Token (可选，通过 token 参数传入)
const getThemeChatHistoryPage = (params = {}, token = null) => ragRequest({
  url: `/api/v1/ai/english/theme/chat/page`,
  method: 'get',
  data: params, // Query 参数：page, pageSize（GET 请求时会将 data 作为 query 参数）
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

// 英语主题对话-获取对话记录
// GET /api/v1/ai/english/theme/chat/{chatRecordId}
// Path 参数：chatRecordId (必需)
// Header 参数：X-Authorization-Token (可选，通过 token 参数传入)
const getThemeChatRecord = (chatRecordId, token = null) => ragRequest({
  url: `/api/v1/ai/english/theme/chat/${chatRecordId}`,
  method: 'get',
  data: {}, // GET 请求不需要 body
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

// 英语主题对话-创建新对话
// POST /api/v1/ai/english/theme/chat/new
// Body 参数：theme (主题), nickname (用户昵称), gradeId (用户年级)
// Header 参数：X-Authorization-Token (可选，通过 token 参数传入)
const newThemeChat = (data = {}, token = null) => ragRequest({
  url: `/api/v1/ai/english/theme/chat/new`,
  method: 'post',
  data, // 请求体参数：theme, nickname, gradeId
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

// 英语主题对话-确认主题
// POST /api/v1/ai/english/theme/confirmTheme
// Body 参数：chatRecordId (对话Id), userMessage (用户发送信息)
// Header 参数：X-Authorization-Token (可选，通过 token 参数传入)
const confirmTheme = (data = {}, token = null) => ragRequest({
  url: `/api/v1/ai/english/theme/confirmTheme`,
  method: 'post',
  data, // 请求体参数：chatRecordId, userMessage
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

// 英语主题对话-发送消息
// POST /api/v1/ai/english/theme/sendChatMessage
// Body 参数：chatRecordId (对话Id), userMessage (用户发送信息)
// Header 参数：X-Authorization-Token (可选，通过 token 参数传入)
const sendThemeChatMessage = (data = {}, token = null, extraOptions = {}) => ragRequest({
  url: `/api/v1/ai/english/theme/sendChatMessage`,
  method: 'post',
  data, // 请求体参数：chatRecordId, userMessage
  token: token, // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
  ...extraOptions
})

// 句子评分接口
// POST /api/v1/english/score/sentence
// Body 参数：sentence (句子), audioBase64 (音频base64)
// Header 参数：X-Authorization-Token (可选，通过 token 参数传入)
const scoreSentence = (data = {}, token = null) => ragRequest({
  url: `/api/v1/english/score/sentence`,
  method: 'post',
  data, // 请求体参数：sentence, audioBase64
  token: token // 传入自定义 token
})

// 课程-查询年级
// GET /api/v1/course/selectGrades
// Query 参数：stageId (可选，不传则获取全部年级)
// Header 参数：X-Authorization-JhbGciOiJIUzUxMiJ9.eyJ1c2VyToken (生产环境使用安卓的token，本地调试使用固定token)
const DEFAULT_GRADE_TOKEN = "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoiNTU1MTExIiwidXNlcl9rZXkiOiI1NTUxMTEiLCJ1dWlkIjoiYTU2YWNlMWMtNTM5Zi00N2NjLWIzZjAtNTcyYTc4NzlhNzcyIiwibGV2ZWxfc29ydCI6bnVsbH0.FEiFGjFX0oNn2146mSbrgHXWQWn-2jGJlB0504ZwqXaVFNiz9X_B3COnuIZ_lFv3w_8u9cR8POQevK3YzRXKGA"
const selectGrades = (token = null) => {
  // 如果传入了token，优先使用传入的token
  if (token) {
    return enhancedRequest({
      url: `/api/v1/course/selectGrades`,
      method: 'get',
      token: token
    });
  }
  
  // 本地调试：使用固定token
  if (process.env.NODE_ENV === 'development') {
    return enhancedRequest({
      url: `/api/v1/course/selectGrades`,
      method: 'get',
      token: DEFAULT_GRADE_TOKEN
    });
  }
  
  // 生产环境：使用安卓的token（从localStorage获取，enhancedRequest会自动处理）
  // enhancedRequest 会从 getToken() 获取token，getToken() 会从 localStorage.getItem("token") 获取
  return enhancedRequest({
    url: `/api/v1/course/selectGrades`,
    method: 'get'
    // 不传token，让enhancedRequest自动从localStorage获取安卓的token
  });
}

export {
  getPromptList,
  newChat,
  resultByTextToTTs,
  audioClose,
  closeChat,
  sendSpokenChatCompletions,
  sendSpokenChatCompletionsStream,
  getChatHistoryPage,
  getThemeChatHistoryPage,
  getThemeChatRecord,
  newThemeChat,
  confirmTheme,
  sendThemeChatMessage,
  scoreSentence,
  selectGrades
}
